import React, { useState } from "react";
import { BiShow, BiHide } from "react-icons/bi";
import { Link } from "react-router-dom";
import { Header, NavBar } from "../../components";
import { useAuth, useTheme } from "../../context";
import { useDocumentTitle } from "../../customHooks";
import "../commonPage.css";
import styles from "./signup.module.css";

export const SignUp = () => {
  useDocumentTitle("SignUp");
  const [showPassword, setShowPassword] = useState(false);
  const { signupUser, signupHandler, setSignUpUser } = useAuth();
  const { theme } = useTheme();
  return (
    <main
      className={`signup-page  ${
        theme === "light" ? "dark-theme" : "light-theme"
      }`}
    >
      <Header />
      <NavBar />
      <section className="form-wrapper">
        <div className={styles.signUpForm__wrapper}>
          <div className={styles.coverImage__wrapper}>
            {signupUser.coverImage && (
              <img
                className={styles.coverImage__img}
                src={URL.createObjectURL(signupUser.coverImage)}
                alt="coverImage"
              />
            )}
            <input
              type="file"
              className={styles.coverImage__input}
              onChange={(e) =>
                setSignUpUser((prev) => ({
                  ...prev,
                  coverImage: e.target.files[0],
                }))
              }
            />
          </div>
          <div className={styles.avatar__wrapper}>
            {signupUser.avatar && (
              <img
                className={styles.avatar__img}
                src={URL.createObjectURL(signupUser.avatar)}
                alt="avatar"
              />
            )}
            <input
              type="file"
              name="avatar"
              className={styles.avatar__input}
              onChange={(e) =>
                setSignUpUser((prev) => ({
                  ...prev,
                  avatar: e.target.files[0],
                }))
              }
            />
          </div>
          <div className={styles.accountDetails__wrapper}>
            <div>
              <label className="input-label">FullName: </label>
              <input
                type="text"
                className="form-field border-radius-xs padding-xs"
                placeholder="fullname"
                required
                onChange={(e) =>
                  setSignUpUser((prev) => ({
                    ...prev,
                    fullName: e.target.value,
                  }))
                }
                value={signupUser.fullName}
              />
            </div>
            <div>
              <label className="input-label">username:</label>
              <input
                type="text"
                className="form-field border-radius-xs padding-xs"
                placeholder="username"
                required
                onChange={(e) =>
                  setSignUpUser((prev) => ({
                    ...prev,
                    username: e.target.value,
                  }))
                }
                value={signupUser.username}
              />
            </div>
            <div>
              <label className="input-label">Email:</label>
              <input
                type="email"
                className="form-field border-radius-xs padding-xs"
                placeholder="email"
                required
                onChange={(e) =>
                  setSignUpUser((prev) => ({ ...prev, email: e.target.value }))
                }
                value={signupUser.email}
              />
            </div>
            <div className="position-rel">
              <label className="input-label">Password: </label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-field border-radius-xs padding-xs"
                placeholder="password"
                required
                onChange={(e) =>
                  setSignUpUser((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }
                value={signupUser.password}
              />
              {showPassword ? (
                <BiShow
                  className="show-hide-icon"
                  onClick={() => setShowPassword((prev) => !prev)}
                />
              ) : (
                <BiHide
                  className="show-hide-icon"
                  onClick={() => setShowPassword((prev) => !prev)}
                />
              )}
            </div>
          </div>
          <div className={styles.button__wrapper}>
            <button
              style={{ width: "95%" }}
              className="btn btn-primary border-radius-xs"
              onClick={signupHandler}
            >
              SignUp
            </button>
          </div>
          <p className="text-center text-sm font-weight-bold text-gray">
            Already have an Account
            <Link to="/login" className="highlight padding-xs">
              Join
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};
